<template>
    <b-form-group label="Tipo de Avaliação*" label-for="tipoDeAvaliacao" label-class="font_size_label">
        <validation-provider #default="{ errors }" name="Tipo de Avaliação" :rules="rules">
            <v-select id="tipoDeAvaliacao" :options="options" v-model="selected" placeholder="Selecione a Avaliação"
                :clearable="true">
                <span slot="no-options">Nenhuma opção selecionável.</span>
            </v-select>
            <small v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
            </small>
        </validation-provider>
    </b-form-group>
</template>

<script>
import {
    BForm,
    BCol,
    BRow,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BSpinner,
    BFormDatepicker,
    BFormTextarea,
    BOverlay,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import vSelect from "vue-select";

export default {
    components: {
        BForm,
        BCol,
        BRow,
        BFormGroup,
        BFormInput,
        BButton,
        BTable,
        BSpinner,
        BFormDatepicker,
        BFormTextarea,
        BOverlay,
        ValidationProvider,
        ValidationObserver,
        vSelect,
    },
    props: {
        value: {
            required: true,
        },
    },
    data() {
        return {
            options: [],
            selected: this.value,
            rules: "required",
        };
    },
    beforeMount() {
        this.options = ['Experiência de Adesão'];
    },
    watch: {
        selected: function (valor) {
            this.$emit("selected", valor);
        },
    },
};
</script>
